import clsx from 'clsx';
import React from 'react';

import { root_path } from '@routes';

interface ViewLinkProps {
  customPath?: ({ view }: { view: string }) => string;
  isActive: boolean;
  role?: string;
  text: string;
  to: string;
}

const ViewLink = ({ customPath, isActive, role = '', text, to }: ViewLinkProps) => {
  return (
    <a
      href={customPath ? customPath({ view: to }) : root_path({ view: to })}
      className={clsx(
        'font-suisse-intl-mono text-overline-lg text-black hover:text-primary-magenta',
        {
          'active pointer-events-none border-0 border-b-[12px] border-solid border-primary-magenta':
            isActive,
        }
      )}
      role={role}
    >
      {text}
    </a>
  );
};

export default ViewLink;
